import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=bbb8ffd2&scoped=true"
import script from "./Done.vue?vue&type=script&lang=js"
export * from "./Done.vue?vue&type=script&lang=js"
import style0 from "./Done.vue?vue&type=style&index=0&id=bbb8ffd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb8ffd2",
  null
  
)

export default component.exports